import React from 'react'
import './posts.scss'

/**
 * A component for displaying a name tag.
 *
 * @param {Object} props.author - The author whose name will be displayed.
 * @param {string} [props.color='white-opacity'] - The text color of the name tag (white, white-opacity or black).
 * @param {string} [props.size='medium'] - The font size  of the name tag ('small', 'medium', 'large', extra-large).
 * @param {string} [props.ballColor='green'] - The color of the ball on the name tag (orange or green).
 * @param {string} [props.mobileColor=''] -  The text color of the name tag (white or black).
 * @returns {JSX.Element} - A React JSX element that displays the name tag.
 */
export const NameTag = ({
  author,
  color = 'white-opacity',
  size = 'medium',
  ballColor = 'green',
  mobileColor = '',
}) => {
  return (
    <div
      className={`name-tag ${color} ${size} ball-${ballColor} ${
        mobileColor ? 'mobile-' + mobileColor : ''
      }`}
    >
      {author.name}
    </div>
  )
}
